/**
 * Local Language Translations for the application.
 *
 * Base/Key of the language is kept as EN.
 */
module.exports = {
  or: {
    en: "OR",
    de: "ODER",
    fr: "OU",
    nl: "OF",
  },
cart_title: {
  en: "Items",
  de: "Artikel",
  fr: "Articles",
  nl: "Artikelen",
},
  reservation: {
    en: "Reservation",
    de: "Reservierung",
    fr: "Reservation",
    nl: "Reservatie",
  },
  leave_contact_details: {
    en: "Leave Contact Details",
    de: "Kontaktdaten hinterlassen",
    fr: "Laisser vos coordonnées",
    nl: "Contactgegevens achterlaten",
  },
  full_name: {
    en: "First name",
    de: "Vorname",
    fr: "Prénom",
    nl: "Naam & Voornaam",
  },
  zip: {
    en: "Zip code",
    de: "Postleitzahl",
    fr: "le code postal",
    nl: "Postcode",
  },
  city: {
    en: "City",
    de: "Stadt",
    fr: "une ville",
    nl: "Stad",
  },
  country: {
    en: "Country",
    de: "Land",
    fr: "un pays",
    nl: "Land",
  },
  address: {
    en: "address",
    de: "Adresse",
    fr: "adresse",
    nl: "adres",
  },
  email: {
    en: "Email",
    de: "Email",
    fr: "Email",
    nl: "Email",
  },
  phone: {
    en: "Phone Number",
    de: "Telefonnummer",
    fr: "Numéro de téléphone",
    nl: "Telefoonnummer",
  },
  submit: {
    en: "Submit",
    de: "Einreichen",
    fr: "Soumettre",
    nl: "Verzenden",
  },
  cancel: {
    en: "Cancel",
    de: "Abbrechen",
    fr: "Annuler",
    nl: "Annuleren",
  },
  resubmit: {
    en: "Resubmit",
    de: "Erneut einreichen",
    fr: "Soumettre à nouveau",
    nl: "Opnieuw indienen",
  },
  submitted_as: {
    en: "Submited as",
    de: "Eingereicht als",
    fr: "Soumis comme",
    nl: "Ingediend als",
  },
  please_enter_valid_email: {
    en: "Please enter a valid email.",
    de: "Bitte geben Sie eine gültige Email-Adresse ein.",
    fr: "Veuillez saisir un e-mail valide.",
    nl: "Gelieve een geldig e-mailadres in te vullen.",
  },
  marketing_consent_description: {
    en: "Keep me up to date with the latest info and special offers.",
    de: "Halten Sie mich mit auf dem Laufenden den neuesten Informationen und Sonderangeboten.",
    fr: "Tenez-moi au courant des dernières informations et offres.",
    nl: "Blijf up to date met onze laatste info en speciale acties.",
  },
  data_deletion_message: {
    en: "We automatically delete your data within 14 days, and won't use it for anything else then contact tracing in case of emergency.",
    de: "Wir löschen Ihre Daten automatisch innerhalb von 14 Tagen und verwenden sie nicht für andere Zwecke als die Rückverfolgung im Notfall.",
    fr: "Nous supprimons automatiquement vos données dans les 14 jours, et ne les utiliserons pas pour autre chose que le suivi des contacts en cas d'urgence.",
    nl: "We verwijderen uw gegevens automatisch binnen 14 dagen en gebruiken ze niets anders dan contacttracering in geval van nood.",
  },
  add_to_cart: {
    en: "Add",
    nl: "Bestel",
    de: "Bestel",
    fr: "Ajoute",
  },
  modifiers_for: {
    en: "Please make your selection for",
    nl: "Gelieve je selecties te maken",
    de: "Bitte auswählen für",
    fr: "Veuillez choisir vos options pour",
  },
  go_to_cart: {
    en: "View order",
    nl: "Bekijk bestelling",
    de: "Bestellung Überprüfen",
    fr: "Finaliser la commande",
  },
  items: {
    en: "items.",
    nl: "producten.",
    de: "produkte.",
    fr: "Articles.",
  },
  and_keyword: {
    en: "and",
    fr: "et",
    nl: "en",
    de: "und",
  },
  quantity: {
    en: "Quantity",
    nl: "Aantal",
    de: "Mänge",
    fr: "Quantité",
  },
  price: {
    en: "Price",
    nl: "Prijs",
    de: "Preis",
    fr: "Prix",
  },
  total: {
    en: "Total",
    nl: "Totaal",
    de: "Summe",
    fr: "Total",
  },
  proceed_to_checkout: {
    en: "Place Order",
    nl: "Bestelling plaatsen",
    de: "Bestellung aufgeben",
    fr: "Passer la commande",
  },
  select_table: {
    en: "Select Table",
    nl: "Selecteer je tafel",
    de: "Wählen Sie Ihren Tisch",
    fr: "Selecter votre table",
  },
  continue_to_payment: {
    en: "Proceed to Payment",
    nl: "Ga door naar betaling",
    de: "Weiter zur Zahlung",
    fr: "Procéder au paiement",
  },
  your_cart: {
    en: "Your Order",
    nl: "Jouw bestelling",
    de: "Ihre Bestellung",
    fr: "Votre commande",
  },
  note_label: {
    en: "Add a note to your order",
    fr: "Ajouter une note à votre commande",
    nl: "Voeg een notitie toe aan uw bestelling",
    de: "Fügen Sie Ihrer Bestellung eine Notiz hinzu",
  },
  extra_note_label: {
    en: "Add a extra note to your order",
    fr: "Ajouter une note supplémentaire à votre commande",
    nl: "Voeg een extra opmerking toe aan je bestelling",
    de: "Fügen Sie Ihrer Bestellung eine zusätzliche Notiz hinzu",
  },
  create_new_order: {
    en: "Create New Order",
    fr: "Créer une nouvelle commande",
    nl: "Start een nieuwe bestelling",
    de: "Neue Bestellung erstellen",
  },
  take_away: {
    en: "Take Away",
    fr: "À emporter",
    nl: "Afhalen",
    de: "Take Away",
  },
  order_details: {
    en: "Order Details",
    fr: "Résumé de votre commande",
    nl: "Bestelling",
    de: "Bestelldetails",
  },
  retry_payment: {
    en: "Retry Payment",
    fr: "Réessayer le paiement",
    nl: "Probeer de betaling opnieuw",
    de: "Versuchen Sie die Zahlung erneut",
  },
  required: {
    en: "Mandatory",
    fr: "Obligatoire",
    nl: "Verplicht",
    de: "Erforderlich",
  },
  minimum_one_item_is_required: {
    en: "Minimun one modifer needs to be selected.",
    fr: "Un minimum d'un modificateur doit être sélectionné.",
    nl: "Er moet minimaal één optie worden geselecteerd.",
    de: "Es muss mindestens eine Option ausgewählt werden.",
  },
  multiple_modifiers_can_be_selected: {
    en: "Multiple modifiers can be selected.",
    fr: "Plusieurs modificateurs peuvent être sélectionnés.",
    nl: "Er kunnen meerdere opties worden geselecteerd.",
    de: "Es können mehrere Optionen ausgewählt werden.",
  },
  only_one_modifier_allowed: {
    en: "Only one modifier is allowed.",
    fr: "Un seul modificateur est autorisé.",
    nl: "Er is slechts één optie toegestaan.",
    de: "Es ist nur eine Option zulässig.",
  },
  add_something_to_cart: {
    en: "Add items",
    fr: "Ajouter des produits",
    nl: "Voeg items toe",
    de: "Etwas hinzufügen",
  },
  order: {
    en: "Order",
    fr: "Commande",
    nl: "Bestelling",
    de: "Bestellung",
  },
  note: {
    en: "Note",
    fr: "Remarque",
    nl: "Notitie",
    de: "Notiz",
  },
  table: {
    en: "Table",
    fr: "Table",
    nl: "Tafel",
    de: "Tisch",
  },
  payment_still_processing: {
    en: "We're still processing your payment, please wait a few seconds.",
    fr: "Nous sommes toujours en train de traiter votre paiement, veuillez patienter quelques secondes.",
    nl: "Uw betaling wordt nog verwerkt. Wacht een paar seconden.",
    de: "Wir bearbeiten Ihre Zahlung noch. Bitte warten Sie einige Sekunden.",
  },
  please_enter_security_code: {
    en: "Please Enter the Security Code.",
    fr: "Entrez le code de sécurité s'il vous plaît.",
    nl: "Voer de beveiligingscode in.",
    de: "Bitte geben Sie den Sicherheitscode ein.",
  },
  security_code: {
    en: "Security Code",
    fr: "Code de sécurité",
    nl: "Beveiligingscode",
    de: "Sicherheitscode",
  },
  valid_security_code: {
    en: "Yay! Security Code is correct.",
    fr: "Yay! Le code de sécurité est correct.",
    nl: "Ja! Beveiligingscode is correct.",
    de: "Yay! Sicherheitscode ist korrekt.",
  },
  invalid_security_code: {
    en: "Incorrect security code.",
    fr: "Code de sécurité incorrect.",
    nl: "Verkeerde beveiligingscode.",
    de: "Falscher Sicherheitscode.",
  },
  please_select_table: {
    en: "Please Select Table.",
    fr: "Veuillez sélectionner la table.",
    nl: "Selecteer de tafel.",
    de: "Bitte wählen Sie Ihren Tisch.",
  },
  something_went_wrong: {
    en: "Something went wrong! Please try again",
    fr: "Quelque chose s'est mal passé! Veuillez réessayer.",
    nl: "Er is iets fout gegaan! Probeer het opnieuw.",
    de: "Etwas ist schief gelaufen! Bitte versuche es erneut.",
  },
  select_time_slot: {
    en: "Select a time",
    fr: "sélectionner une heure",
    nl: "Selecteer een tijd",
    de: "Wählen Sie eine Abholzeit",
  },
  select_day: {
    en: "Select a day",
    fr: "Sélectionner un jour",
    nl: "Selecteer een dag",
    de: "wählen einen Tag aus",
  },
  no_time_slots: {
    en: "No time slots available",
    fr: "Sélectionner un jour",
    nl: "Geen tijdssloten beschikbaar",
    de: "Wähle einen Tag aus",
  },
  meer_dagen: {
    en: "More days",
    fr: "Plus de jours",
    nl: "Meer dagen",
    de: "Mehr Tage",
  },
  minder_dagen: {
    en: "Less days",
    fr: "Moins de jours",
    nl: "Minder dagen",
    de: "Weniger Tage",
  },
  search_for_food: {
    en: "Search for food",
    fr: "Recherche de nourriture",
    nl: "Zoek naar eten",
    de: "Suche nach Nahrung",
  },
  menu_Items: {
    en: "Menu items",
    fr: "Éléments du menu",
    nl: "Menu items",
    de: "Menüpunkte",
  },
  select_items: {
    en: "Items",
    fr: "Les articles",
    nl: "Items",
    de: "Artikel",
  },
  contact_details: {
    en: "Contact details",
    fr: "Détails client",
    nl: "Contact gegevens",
    de: "Kontaktdetails",
  },
  payment: {
    en: "Pay",
    fr: "Payer",
    nl: "Betaal",
    de: "Zahlen",
  },
  "": {
    en: "",
    fr: "",
    nl: "",
    de: "",
  },
  Home: {
    en: "Home",
    fr: "Accueil",
    nl: "Home",
    de: "Zuhause",
  },
  Menu: {
    en: "Menu",
    fr: "Menu",
    nl: "Menu",
    de: "Speisekarte",
  },
  discount: {
    en: "Discount",
    fr: "Remise",
    nl: "Korting",
    de: "Rabatt",
  },
  nuts: {
    en: "Nuts",
    fr: "Noix",
    nl: "Noten",
    de: "Nüsse",
  },
  soy: {
    en: "Soy",
    fr: "Soja",
    nl: "Soja",
    de: "Soja",
  },
  peanut: {
    en: "Peanut",
    fr: "Cacahuète",
    nl: "Pinda",
    de: "Erdnuss",
  },
  gluten: {
    en: "Gluten",
    fr: "Gluten",
    nl: "Gluten",
    de: "Gluten",
  },
  fish: {
    en: "Fish",
    fr: "Poisson",
    nl: "Vis",
    de: "Fisch",
  },
  milk: {
    en: "Milk",
    fr: "Lait",
    nl: "Melk",
    de: "Milch",
  },
  egg: {
    en: "Egg",
    fr: "Oeuf",
    nl: "Ei",
    de: "Ei",
  },
  meat: {
    en: "Meat",
    fr: "Viande",
    nl: "Vlees",
    de: "Fleisch",
  },
  vegetarian: {
    en: "Vegetarian",
    fr: "Végétarien",
    nl: "Vegetarisch",
    de: "Vegetarier",
  },
  vegan: {
    en: "Vegan",
    fr: "Végétalien",
    nl: "Veganistisch",
    de: "Vegan",
  },
  sugar_free: {
    en: "Sugarfree",
    fr: "Sans sucre",
    nl: "Suikervrij",
    de: "Zuckerfrei",
  },
  mustard: {
    en: "Mustard",
    fr: "Moutarde",
    nl: "Mosterd",
    de: "Senf",
  },
  mollusc: {
    en: "Mollusc",
    fr: "Mollusque",
    nl: "Weekdier",
    de: "Weichtier",
  },
  crustaceans: {
    en: "Crustaceans",
    fr: "Crustacés",
    nl: "Schaaldieren",
    de: "Krebstiere",
  },
  lupin: {
    en: "Lupin",
    fr: "Lupine",
    nl: "Wolvin",
    de: "Lupine",
  },
  celery: {
    en: "Celery",
    fr: "Céleri",
    nl: "Selderij",
    de: "Sellerie",
  },
  sesame: {
    en: "Sesame",
    fr: "Sésame",
    nl: "Sesam",
    de: "Sesam",
  },
  sulphites: {
    en: "Sulphites",
    fr: "Sulfites",
    nl: "Sulfieten",
    de: "Sulfite",
  },
  menu_category: {
    en: "Menu Category",
    fr: "Catégorie de menu",
    nl: "Menu categorie",
    de: "Menükategorie",
  },
  my_order: {
    en: "My Order",
    fr: "Ma commande",
    nl: "Mijn bestelling",
    de: "Meine Bestellung",
  },
  Time: {
    en: "Time",
    fr: "Temps",
    nl: "Tijdsslot",
    de: "Zeit",
  },
  number_of_guests: {
    en: "Number of guests",
    fr: "Nombre d'invités",
    nl: "Aantal gasten",
    de: "Anzahl der Gäste",
  },
  fee: {
    en: "Servicekosten",
    fr: "Servicekosten",
    nl: "Servicekosten",
    de: "Servicekosten",
  },
  tip: {
    en: "Tip",
    fr: "Tip",
    nl: "Tip",
    de: "Tip",
  },
  min_order_Amount: {
    en: "Order at least above",
    fr: "Order at least above",
    nl: "Order at least above",
    de: "Order at least above",
  },
  information: {
    en: "There is a minimum order amount for this menu ",
    fr: "Il y a un montant minimum de commande pour ce menu ",
    nl: "Voor dit menu geldt een minimum bestelbedrag van ",
    de: "Für dieses Menü gibt es einen Mindestbestellwert ",
  },
  information_delivery: {
    en: "Free shipping from ",
    fr: "Livraison gratuite de ",
    nl: "Gratis verzending vanaf ",
    de: "Kostenloser Versand ab ",
  },
  information_extra: {
    en: ". If you order less, there is a surcharge ",
    fr: ". Si vous commandez moins, il y a un supplément ",
    nl: ". Indien je minder bestelt geldt er een toeslag van ",
    de: ". Wenn Sie weniger bestellen, fällt ein Aufpreis an ",
  },
  information_extra_extra: {
    en: ". Order a little more to complete your order.",
    fr: ". Commandez un peu plus pour terminer votre commande.",
    nl: ". Bestel iets meer om je bestelling af te ronden.",
    de: ". Bestellen Sie etwas mehr, um Ihre Bestellung abzuschließen.",
  },
  Charges: {
    en: "Charges",
    fr: "Des charges",
    nl: "Toeslag",
    de: "Gebühren",
  },
  go_back_to_your_order: {
    en: "Back to your order",
    fr: "Retourner à votre commande",
    nl: "Terug naar jouw bestelling",
    de: "zurück zu Ihrer Bestellung",
  },
  completed: {
    en: "Your order is completed",
    fr: "Votre commande est terminée",
    nl: "Uw bestelling is voltooid",
    de: "Ihre Bestellung ist abgeschlossen",
  },
  discount_code: {
    en: "Discount code",
    fr: "Code de réduction",
    nl: "Kortingscode",
    de: "Rabattcode",
  },
  discount_amount: {
    en: "Discount amount",
    fr: "montant de la remise",
    nl: "Kortingsbedrag",
    de: "Rabattbetrag",
  },
  discount_invalid_code: {
    en: "The discount code you entered is not (longer) valid.",
    fr: "Le code de réduction que vous avez entré n'est (plus) valide.",
    nl: "De kortingscode die je ingaf is niet (meer) geldig.",
    de: "Der von Ihnen eingegebene Rabattcode ist nicht (mehr) gültig.",
  },
  discount_max_reached: {
    en: "The maximum amount of the discount is ",
    fr: "Le montant maximum de la réduction est ",
    nl: "Het maximum aantal korting bedraagt ",
    de: "Der maximale Rabattbetrag beträgt ",
  },
  discount_low_items: {
    en: "To take advantage of the discount, choose at least ",
    fr: "Pour profiter de la réduction, choisissez au moins ",
    nl: "Om gebruik te maken van de korting, kies minimaal ",
    de: "Um den Rabatt zu nutzen, wählen Sie mindestens ",
  },
  discount_min_price: {
    en: "To take advantage of the discount, order at least for ",
    fr: "Pour profiter de la réduction, commandez au minimum ",
    nl: "Om gebruik te maken van de korting, bestel voor minimum ",
    de: "Um den Rabatt zu nutzen, bestellen Sie mindestens ",
  },
  Delivery: {
    en: "Delivery",
    nl: "Leveren aan huis",
    de: "Hauslieferung",
    fr: "Livraison",
  },
  DeliveryDistanceOutOfRange: {
    en: "The filled in address is too far for delivery",
    nl: "Het ingevoerde adres is te ver om te leveren",
    de: "Die eingegebene Adresse ist zu weit, um zu liefern",
    fr: "l'adresse saisie est trop éloignée pour livrer",
  },
  DeliveryCosts: {
    en: "Delivery costs",
    nl: "Leverkosten",
    de: "Versandkosten",
    fr: "Coûts de livraison",
  },

  languageSettings: {
    en: "Choose your language",
    fr: "Paramètres de langue",
    nl: "Kies je taal",
    de: "Wähle diene sprache",
  },
  Fee_Payment: {
    en: "Order for",
    fr: "Commandez pour",
    nl: "Bestel nog voor",
    de: "Bestellen Sie für",
  },
  No_Fee_Payment: {
    en: "extra and pay no extra charge",
    fr: "supplémentaires et ne payez pas de frais supplémentaires",
    nl: "extra en betaal geen extra toeslag",
    de: "extra und zahlen Sie keinen Aufpreis",
  },
  what_to_eat: {
    en: "Where do you want to eat today?",
    fr: "Où voulez-vous manger aujourd'hui?",
    nl: "Waar wil je eten vandaag?",
    de: "Wo willst du heute essen?",
  },
  dine_in: {
    en: "Dine-in",
    fr: "Sur place",
    nl: "Ter plaatse",
    de: "Iss hier",
  },
  error: {
    en: "Something went wrong.",
    nl: "Er is iets misgelopen.",
    fr: "Un problème est survenu.",
    de: "Etwas ist schief gelaufen.",
  },
  reload_page: {
    en: "Reload the page",
    nl: "Herlaad de pagina",
    fr: "Recharge la page",
    de: "Seite aktualisieren",
  },
  payment_failed: {
    en: "Payment failed.",
    fr: "Paiement échoué.",
    nl: "Betaling mislukt.",
    de: "Bezahlung fehlgeschlagen.",
  },
  show_order: {
    en: "View your order below",
    fr: "Consultez votre commande ci-dessous",
    nl: "Bekijk hieronder je bestelling",
    de: "Sehen Sie sich Ihre Bestellung unten an",
  },
  cancel_order: {
    en: "Cancel order",
    fr: "Annuler la commande",
    nl: "Bestelling annuleren",
    de: "Bestellung stornieren",
  },
  cancel_order_question: {
    en: "Cancel order",
    fr: "Annuler la commande",
    nl: "Bestelling annuleren",
    de: "Bestellung stornieren",
  },
  terms: {
    en: "Terms & Privacy Policy",
    nl: "Voorwaarden & Privacybeleid",
    fr: "Conditions d'utilisation et politique de confidentialité",
    de: "Nutzungsbedingungen und Datenschutzbestimmungen",
  },
  bus_number: {
    en: "Bus number",
    fr: "numéro de bus",
    nl: "Busnummer",
    de: "Bus Nummer",
  },
  table_manual_number: {
    en: "Enter your table number",
    fr: "Entrez votre numéro de table",
    nl: "Geef je tafelnummer in",
    de: "Geben Sie Ihre Tischnummer ein",
  },
  table_number: {
    en: "Table number",
    fr: "Numéro de table",
    nl: "Tafelnummer",
    de: "Tischnummer",
  },
  email_not_valid: {
    en: "Invalid email address",
    fr: "Adresse e-mail invalide",
    nl: "Ongeldig e-mailadres",
    de: "Ungültige E-Mail-Adresse",
  },
  view_order: {
    en: "View order",
    fr: "Valider la commande",
    nl: "Bestelling bekijken",
    de: "Bestellung anzeigen",
  },
  payment_pending: {
    en: "Waiting for payment!",
    fr: "En attente de paiement",
    nl: "Wachten op betaling",
    de: "Warten auf Zahlung",
  },
  payment_not_received: {
    en: "Payment not received yet, please wait",
    fr: "Paiement pas encore reçu, veuillez patienter",
    nl: "Betaling nog niet ontvangen, even geduld aub",
    de: "Zahlung noch nicht eingegangen, bitte warten",
  },
  festival_order_text: {
    en: "overview",
    fr: "Aperçu",
    nl: "Overzicht",
    de: "Überblick",
  },
  disount_error: {
    en: "Total amount too small to use this discount. Order a little more to take advantage of this discount.",
    fr: "Montant total trop petit pour utiliser cette remise. Commandez un peu plus pour profiter de cette remise.",
    nl: "Totaalbedrag te klein om deze korting te gebruiken. Bestel iets meer om gebruik te maken van deze korting.",
    de: "Gesamtbetrag zu klein, um diesen Rabatt zu nutzen. Bestellen Sie etwas mehr, um von diesem Rabatt zu profitieren.",
  },
  redirecting_payment: {
    en: "Redirecting to payment",
    fr: "Rediriger vers le paiement",
    nl: "Betaling wordt uitgevoerd",
    de: "Weiterleitung zur Zahlung",
  },
  continue_ordering: {
    en: "Do you still want to continue ordering?",
    fr: "Voulez-vous continuer à commander?",
    nl: "Wil je nog doorgaan met bestellen?",
    de: "Möchten Sie weiterhin bestellen?",
  },
  touch_screen: {
    en: "Touch the screen to continue",
    fr: "Touchez l'écran pour continuer",
    nl: "Raak het scherm aan om verder te gaan",
    de: "Berühren Sie den Bildschirm, um fortzufahren",
  },
  continue_order: {
    en: "Continue ordering",
    fr: "Continuer la commande",
    nl: "Doorgaan met bestellen",
    de: "Weiter bestellen",
  },
  thank_you: {
    en: "Thank you",
    fr: "Merci",
    nl: "Bedankt",
    de: "Vielen Dank",
  },
  order_type: {
    en: "Order type",
    fr: "Commande taper",
    nl: "Bestelling type",
    de: "Bestellung typ",
  },
  forgot_something: {
    en: "Forgot something?",
    fr: "Oublié quelque chose?",
    nl: "Iets vergeten?",
    de: "Etwas vergessen",
  },
  go_back: {
    en: "Go back",
    fr: "Retour",
    nl: "Ga terug",
    de: "Zurück",
  },
  no_thanks: {
    en: "No, thank you",
    fr: "Non, merci",
    nl: "Nee, bedankt",
    de: "Nein, danke",
  },
  available_betweens: {
    en: "available between",
    fr: "disponible entre",
    nl: "beschikbaar tussen",
    de: "verfügbar zwischen",
  },
  order_disabled: {
    en: "Order disabled",
    fr: "Commande désactivée",
    nl: "Bestellen uitgeschakeld",
    de: "Bestellung deaktiviert",
  },
  please_wait: {
    en: "Please wait a moment",
    fr: "Patientez s'il-vous-plait",
    nl: "Even geduld",
    de: "Bitte warte einen moment",
  },
  payment_loading: {
    en: "We are loading your payment",
    fr: "Nous chargeons votre paiement",
    nl: "We laden je betaling",
    de: "Wir laden Ihre Zahlung",
  },
  are_you_sure_cancel: {
    en: "Are you sure you want to cancel your order?",
    fr: "Êtes-vous sûr de vouloir annuler votre commande ?",
    nl: "Weet u zeker dat u uw bestelling wilt annuleren?",
    de: "Möchten Sie Ihre Bestellung wirklich stornieren?",
  },
  edit_order: {
    en: "Edit cart item",
    fr: "Modifier",
    nl: "Bewerk bestelling",
    de: "Artikel anpassen",
  },
  edit_order_top_notify: {
    en: "Edit your order",
    fr: "Modifier votre commande",
    nl: "Bewerk je order",
    de: "Bearbeiten Sie Ihre Bestellung",
  },
  save_edited_order: {
    en: "Save edited item",
    fr: "Enregistrer",
    nl: "Item opslaan",
    de: "Artikel speichern",
  },
  scan_qr_code: {
    en: "Scan your qr code here",
    fr: "Scannez votre code QR ici",
    nl: "Scan hier uw QR code",
    de: "Scannen Sie hier Ihren QR-Code",
  },
  add_additions: {
    en: "Make your choice",
    fr: "Fais ton choix",
    nl: "Maak je keuze",
    de: "Treffen Sir Ihre Wahl",
  },
  current_chosen_address: {
    en: "Currently chosen address",
    fr: "Adresse actuellement choisie",
    nl: "Huidig gekozen address",
    de: "Aktuell gewählte Adresse",
  },
  maximum_addition_selection: {
    en: "Max",
    fr: "Max",
    nl: "Max",
    de: "Max",
  },
  minimum_addition_selection: {
    en: "Min",
    fr: "Min",
    nl: "Min",
    de: "Min",
  },
  confirm_my_order: {
    en: "Confirm my order",
    fr: "Confirmer ma commande",
    nl: "Bevestig mijn bestelling",
    de: "Bestätige meine Bestellung",
  },
  ordering_not_available: {
    en: "Ordering is not available",
    fr: "La commande n'est pas disponible",
    nl: "Bestellen is niet mogelijk",
    de: "Bestellung ist nicht möglich",
  },
  no_payment_method_found: {
    nl: "Er zijn geen betalingsmogelijkheden beschikbaar, vraag het personeel om hulp.",
    en: "Payment options are not available, please ask the staff for assistance.",
    fr: "Les options de paiement ne sont pas disponibles, veuillez demander de l'aide au personnel.",
    de: "Es stehen keine Zahlungsmöglichkeiten zur Verfügung, bitte fragen Sie das Personal um Hilfe.",

  },
  thank_you_message: {
    en: "Thank you for your order",
    nl: "Bedankt voor uw bestelling",
    fr: "Nous vous remercions de votre commande",
    de: "Vielen Dank für Ihren Auftrag",
  },
  add_to_order: {
    en: "Add to order",
    fr: "Ajouter à la commande",
    nl: "Toevoegen aan bestelling",
    de: "Zur Bestellung hinzufügen",
  },
  next: {
    en: "Next",
    fr: "Suivant",
    nl: "volgende",
    de: "Nächste",
  },
  choose_your: {
    en: "Choose Your ",
    fr: "Choisi ton ",
    nl: "Kies jouw ",
    de: "Wähle dein ",
  },
  tip_amount: {
    en: "Tip Amount",
    fr: "Montant du pourboire",
    nl: "Fooibedrag",
    de: "Trinkgeldbetrag",
  },
  other_extra_charge: {
    en: "Other Extra Charges",
    fr: "Autres frais supplémentaires",
    nl: "Andere extra kosten",
    de: "Sonstige Nebenkosten",
  },
  extra_charges: {
    en: "Extra Charges",
    fr: "Frais supplémentaires",
    nl: "Extra Kosten",
    de: "Extrakosten",
  },
  contact_support: {
    en: "Please contact support to activate this feature",
    nl: "Neem contact met support op om deze feature te activeren",
    fr: "Veuillez contacter le support pour activer cette fonctionnalité",
    de: "Bitte wenden Sie sich an den Support, um diese Funktion zu aktivieren"
  },
  sold_out: {
    en: "Sold Out",
    fr: "Épuisé",
    nl: "Uitverkocht",
    de: "EAusverkauft",
  },
  as_soon_as_possible: {
    en: "As soon as possible",
    fr: "Dès que possible",
    nl: "Zo snel mogelijk",
    de: "So bald wie möglich",
  },
  space: {
    en: "Space",
    nl: "Spatie",
    fr: "Espace",
    de: "Leertaste",
  },
  enter: {
    en: "Enter",
    nl: "Enter",
    fr: "Entrer",
    de: "Enter",
  },
  close: {
    en: "Close",
    nl: "Sluiten",
    fr: "Fermer",
    de: "Schließen"
  },
  collect_ticket: {
    en: "Please collect your ticket",
    fr: "Veuillez retirer votre ticket",
    nl: "Neem het ticketje",
    de: "Bitte holen Sie Ihr Ticket ab"
  },
  vat_number: {
    en: "VAT Number",
    de: "Umsatzsteuer-Identifikationsnummer",
    fr: "Numéro de TVA",
    nl: "Btw-nummer",
  },
  loyalty_discount: {
    en: "Loyalty Discount",
    de: "Treuerabatt",
    fr: "Remise de fidélité",
    nl: "Loyaliteitskorting"
  },
  choose_company: {
    en: "Choose company if registered",
    de: "Choose company if registered",
    fr: "Choose company if registered",
    nl: "Kies uw bedrijf (indien reeds klant)"
  },
  search: {
    en: "Search",
    de: "Suchen",
    fr: "Chercher",
    nl: "Zoeken"
  },
  make_choice: {
    en: "Make a choice",
    nl: "Maak je keuze",
    fr: "faites un choix",
    de: "entscheide dich"
  },
  please_select: {
    en: "Please select",
    nl: "Kies alstublieft",
    de: "Bitte auswählen",
    fr: "Veuillez sélectionner",
  },
  type_here: {
    en: "Type here",
    nl: "Typ hier",
    de: "Hier eingeben",
    fr: "Tapez ici",
  },
  yes: {
    en: "Yes",
    de: "Ja",
    fr: "Oui",
    nl: "Ja",
  },
  no: {
    en: "No",
    de: "Nein",
    fr: "Non",
    nl: "Nee",
  }


};
